let getters = {
  operators (state) {
    return state.operators
  },
  regions (state) {
    return state.regions
  },
  plans (state) {
    return state.plans
  },
  planCategories (state) {
    return state.planCategories
  },
  filteredPlans (state) {
    return state.filteredPlans
  },
  amount (state) {
    return state.amount
  },
  operator (state) {
    return state.operator
  },
  region (state) {
    return state.region
  },
  recharge_account_id (state) {
    return state.recharge_account_id
  },
  valid_recharge_account_id (state) {
    return state.valid_recharge_account_id
  },
  selectedPlan (state) {
    return state.selectedPlan
  },
  selectedPlanDescription (state) {
    return state.selectedPlanDescription
  },
  selectedCategory (state) {
    return state.selectedCategory
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/recharge/getters.js